import { ShieldOff } from "lucide-react";

import { VoltEmpty } from "../ui/VoltEmpty";

export const AccountingDenied = ({ reason }: { reason?: string | null }) => (
  <VoltEmpty
    icon={ShieldOff}
    title="Kein Zugang zum Accounting"
    description={reason ?? "Das Accounting ist nur für Superadmins."}
  />
);
